import { useCallback } from 'react';

/**
 * Vehicle Path Selection Hook
 * Handles path selection state and calculates available points for selected vehicles
 */
export const useVehiclePathSelection = ({
  vehiclePaths,
  selectedVehicleIndex,
  locations,
  startId
}) => {
  // Calculate points available for the currently selected vehicle
  const getRemainingPoints = useCallback(() => {
    if (selectedVehicleIndex === null) return [];
    
    const currentVehicle = vehiclePaths[selectedVehicleIndex];
    
    if (!currentVehicle) return [];
    
    // Filter available points:
    // 1. Points not in current vehicle path
    // 2. Points not in any other vehicle path (excluding start point)
    return locations.filter(point => {
      // If point already exists in current vehicle path, it's not available
      const inCurrentPath = currentVehicle.path.some(pathPoint => 
        pathPoint && point && pathPoint.id === point.id
      );
      
      if (inCurrentPath) return false;
      
      // If it's start point, it's always available
      if (point.id === startId) return true;
      
      // Check if point already exists in other vehicle paths
      const inOtherPath = vehiclePaths.some((vehicle, idx) => 
        idx !== selectedVehicleIndex && // Not current vehicle
        vehicle.path.some(pathPoint => 
          pathPoint && point && pathPoint.id === point.id
        )
      );
      
      // If not in other paths, it's available
      return !inOtherPath;
    });
  }, [locations, selectedVehicleIndex, vehiclePaths, startId]);

  return {
    getRemainingPoints
  };
}; 